import { useTranslation } from 'react-i18next';

import { Carousel, useCarousel } from '../Carousel';
import * as CarouselStyled from '../Carousel/Carousel.styles';
import { Content, ContentWrapper } from '../Content';
import { reviews } from './data';
import ReviewCard from './ReviewCard';
import * as Styled from './Reviews.styles';

const Reviews = () => {
  const { t } = useTranslation();

  const {
    slidesPerView,
    gap,
    offset,
    scrollPrev,
    scrollNext,
    canScrollPrev,
    canScrollNext,
  } = useCarousel(reviews.length);

  return (
    <Styled.Reviews id="reviews">
      <ContentWrapper>
        <Content
          labels={[t('homeReviews.label')]}
          title={t('homeReviews.title')}
        />

        <Styled.CarouselWrap>
          <Carousel>
            <Carousel.Viewport>
              <Carousel.Container offset={offset}>
                {reviews.map((review) => (
                  <Carousel.Item
                    key={review.id}
                    slidesPerView={slidesPerView}
                    gap={gap}
                  >
                    <ReviewCard review={review} />
                  </Carousel.Item>
                ))}
              </Carousel.Container>
            </Carousel.Viewport>

            <CarouselStyled.Nav>
              <Carousel.Previous
                onClick={scrollPrev}
                disabled={!canScrollPrev}
                aria-label={t('homeReviews.prev')}
              />
              <Carousel.Next
                onClick={scrollNext}
                disabled={!canScrollNext}
                aria-label={t('homeReviews.next')}
              />
            </CarouselStyled.Nav>
          </Carousel>
        </Styled.CarouselWrap>
      </ContentWrapper>
    </Styled.Reviews>
  );
};

export default Reviews;
